import { useState } from "react";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { BsLink45Deg } from "react-icons/bs";
import { CopyToClipboard } from "react-copy-to-clipboard";
import classNames from "classnames";

import BackgroundStyle from "./BackgroundStyle";
import NotifyToastContainer, { notify } from "./NotifyToastContainer";
import { FaBookReader } from "react-icons/fa";
import WebShareIcon from "./icons/WebShareIcon";
import SocialShareIcons from "./icons/SocialShareIcons";

const SocialShareMarkdownRender = ({
  title,
  caption,
  url,
  readTime,
  markdownData,
}) => {
  const [value, setValue] = useState(url);
  const [copied, setCopied] = useState(false);

  return (
    <>
      <div className="flex flex-col sm:flex-row justify-between items-center max-w-prose mx-auto pt-5 px-6 sm:px-0 md:px-0 lg:px-0 xl:px-0 2xl:px-0">
        <div className="text-xs sm:text-sm mb-8 sm:mb-0 text-gray-500 inline-flex items-center justify-center sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0">
          <FaBookReader className="mr-[7px] w-4 h-4" />{" "}
          {`${readTime}  minute read`}
        </div>

        <div className="flex justify-center items-center sm:justify-end sm:items-end space-x-2 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0">
          <SocialShareIcons title={title} caption={caption} url={url} />

          <CopyToClipboard
            text={value}
            onCopy={() => {
              setCopied({ copied: true });
              setValue(url);
            }}
          >
            <BsLink45Deg
              onClick={notify}
              size={30}
              className={classNames(
                copied ? "text-green-600" : "",
                "cursor-pointer text-gray-500 hover:text-black"
              )}
            />
          </CopyToClipboard>

          <WebShareIcon title={title} caption={caption} url={url} />
        </div>
      </div>

      <div className="relative py-10 overflow-hidden sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0">
        <BackgroundStyle />
        <div className="relative px-6 sm:px-0 md:px-0 lg:px-0 xl:px-0 2xl:px-0 max-w-prose mx-auto">
          <div className="text-sm sm:text-lg">
            {" "}
            <ReactMarkdown className="markdown" remarkPlugins={[remarkGfm]}>
              {markdownData}
            </ReactMarkdown>
          </div>
        </div>
      </div>

      {copied ? <NotifyToastContainer /> : null}
    </>
  );
};

export default SocialShareMarkdownRender;
